import { Heading, Image } from '@frontendmentorio/design-system-v2';

export default function Why() {
  return (
    <div className="px-5 py-9">
      <div className="container-xl flex flex-col items-center gap-8">
        <Heading className="max-w-[20ch] text-center" level="3" tagName="h2">
          Why developers choose Frontend Mentor
        </Heading>

        <div className="flex flex-col gap-6 tablet:gap-7 tablet:max-w-prose desktop:flex-row-reverse desktop:items-center desktop:max-w-none">
          <Image
            alt="Landing page in desktop and mobile views with icons of various popular front-end technologies"
            className="desktop:w-1/2"
            height={960}
            src="/static/images/home-why-1.webp"
            width={1164}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Move beyond passive learning
            </Heading>

            <p className="text-lg text-neutral-500">
              Stop watching and start creating. Build professional-quality
              projects that develop genuine coding skills through hands-on
              practice.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:gap-7 tablet:max-w-prose desktop:flex-row desktop:items-center desktop:max-w-none">
          <Image
            alt="Landing pages and dashboards of several full-stack projects"
            className="desktop:w-1/2"
            height={960}
            src="/static/images/home-why-2.webp"
            width={1164}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Create a portfolio that gets you hired
            </Heading>

            <p className="text-lg text-neutral-500">
              Build impressive projects with professional designs. Recruiters
              tell us these portfolio pieces consistently "wow" them in
              interviews by demonstrating real-world capabilities.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:gap-7 tablet:max-w-prose desktop:flex-row-reverse desktop:items-center desktop:max-w-none">
          <Image
            alt="Code editor with AI chat and icons of a few popular AI tools"
            className="desktop:w-1/2"
            height={960}
            src="/static/images/home-why-3.webp"
            width={1164}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Master AI-powered development workflows
            </Heading>

            <p className="text-lg text-neutral-500">
              Practice with AI tools that 76% of developers use daily. Learn to
              work effectively with Cursor, GitHub Copilot, ChatGPT, and other
              assistants while maintaining code quality and problem-solving
              skills.
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-6 tablet:gap-7 tablet:max-w-prose desktop:flex-row desktop:items-center desktop:max-w-none">
          <Image
            alt="Feedback from a few users on a solution another user submitted"
            className="desktop:w-1/2"
            height={960}
            src="/static/images/home-why-4.webp"
            width={1164}
          />

          <div className="flex flex-col gap-6 desktop:w-1/2">
            <Heading level="4" tagName="h3">
              Join a supportive developer community
            </Heading>

            <p className="text-lg text-neutral-500">
              Connect with peers for code reviews, career advice, and
              friendship. Beat imposter syndrome alongside developers who
              understand your journey, guided by mentors who've walked this
              path.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
